/**
 * One way to count who a campaign is going to.
 *
 * Campaign configs come in two shapes. A single-channel programme keeps its
 * recipients at campaign_config.recipients; a multi-channel one keeps a
 * channels[] array, each entry with its own list. Different views read
 * different shapes, so the same campaign was reported with different
 * recipient counts in different places -- the edit view showed one recipient
 * for "test two" while the campaign list showed two patients, and nobody
 * could tell which was true. The backend reads channels[].recipients and was
 * always right; only the displays disagreed.
 *
 * Everything that shows a recipient count reads this.
 */
export function configRecipients(cfg) {
  if (!cfg) return [];
  if (Array.isArray(cfg.recipients)) return cfg.recipients;
  if (Array.isArray(cfg.channels)) {
    // One person selected once is one recipient, even across three channels.
    const seen = new Set();
    for (const ch of cfg.channels) {
      for (const r of (ch?.recipients || [])) seen.add(r);
    }
    return [...seen];
  }
  return [];
}

/** How many people this campaign reaches. */
export function recipientCount(cfg) {
  return configRecipients(cfg).length;
}

/** "3 recipients" / "1 recipient" / "No recipients yet". */
export function recipientLabel(cfg) {
  const n = recipientCount(cfg);
  if (n === 0) return 'No recipients yet';
  return `${n} recipient${n === 1 ? '' : 's'}`;
}
